import { Grid } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import RxButton from "../../../components/RxButton";
import RxDialog from "../../../components/RxDialog";
import { RxDialogState } from "../../../components/RxDialog/RxDialog";
import RxTextField from "../../../components/RxTextField";
import RxTypography from "../../../components/RxTypography";
import api from "../../../config/AxiosConfig";
import { addNotification } from "../../../redux/slices/notification-slice";
import { store } from "../../../redux/store";
import MailApproveValidationSchema from "./MailApproveValidationSchema";

interface MailApproveProps {
	show: boolean;
	email: string;
	setEmail: (value: string) => void;
	setValidationStatus: (value: boolean) => void;
	onClose: () => void;
}

const MailApprove = (props: MailApproveProps) => {
	const [dialogState, setDialogState] = useState<RxDialogState>({
		isOpen: false,
		status: "info",
		message: "",
		title: "",
	});

	const initialValues = {
		email: props.email ?? "",
		code: "",
		isCodeSend: false,
		errorMessage: "",
	};

	const formik = useFormik({
		initialValues,
		validationSchema: MailApproveValidationSchema,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {},
	});

	useEffect(() => {
		setDialogState((prevState: RxDialogState) => {
			return { ...prevState, isOpen: props.show };
		});
	}, [props.show]);

	const validationSuccess = () => {
		props.setEmail(formik.values.email);
		props.setValidationStatus(true);
		store.dispatch(
			addNotification({
				message: `İletişim e-posta adresiniz ${formik.values.email} olarak düzenlenmiştir.`,
				type: "success",
			})
		);
		onClose();
	};

	const sendApprovelMail = () => {
		api.put(
			"/1/users/validate-communication-mail",
			{
				email: formik.values.email,
			},
			{ "content-type": "application/json" },
			true
		).then((response) => {
			switch (response.status) {
				case 200:
					validationSuccess();
					break;
				case 201:
					formik.setFieldValue("isCodeSend", true);
					props.setEmail(formik.values.email);
					props.setValidationStatus(false);
					break;
				case 202:
					formik.setFieldValue("isCodeSend", true);
					props.setEmail(formik.values.email);
					props.setValidationStatus(false);
					formik.setFieldValue("errorMessage", response.data.message);
					break;
			}
		});
	};

	const validateMail = () => {
		api.put(`/1/users/validate-communication-mail/${formik.values.code}`, {
			email: formik.values.email,
		}).then((response) => {
			validationSuccess();
		});
	};

	const onClose = () => {
		formik.setValues(initialValues);
		props.onClose();
	};

	return (
		<RxDialog title="" open={dialogState.isOpen} actions={<></>}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<RxTypography
						label="İletişim e-posta adresinizi değiştirmek için aşağıdaki kutucuğa aktif olarak kullandığınız e-posta adresinizi giriniz. 'Doğrulama E-Postası Gönder' düğmesi ile girdiğiniz e-posta adresinize doğrulama e-postası gönderilecektir. "
						variant="subtitle1"
						align="justify"
					/>
				</Grid>
				<Grid item xs={12}>
					<RxTextField
						fullwidth
						id="email"
						name="email"
						label="E-Posta"
						placeholder="E-Posta"
						value={formik.values.email}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						error={Boolean(formik.errors.email)}
						helperText={formik.errors.email}
						disabled={formik.values.isCodeSend}
					/>
				</Grid>
				<Grid item xs={9}>
					<RxButton
						fullWidth
						label="DOĞRULAMA E-POSTASI GÖNDER"
						variant="contained"
						color="primary"
						disabled={formik.values.isCodeSend}
						onClick={() => sendApprovelMail()}
					/>
				</Grid>
				<Grid item xs={3}>
					<RxButton
						fullWidth
						label="VAZGEÇ"
						variant="contained"
						color="secondary"
						onClick={() => onClose()}
					/>
				</Grid>
				{formik.values.errorMessage !== "" && (
					<>
						<Grid item xs={12}>
							<RxTypography
								variant="subtitle1"
								color="secondary"
								label={formik.values.errorMessage}
							/>
						</Grid>
					</>
				)}
				{formik.values.isCodeSend && (
					<>
						<Grid item xs={12}>
							<RxTypography
								variant="subtitle1"
								label="Lütfen e-posta adresinize gönderilen doğrulama kodunu aşağıdaki kutucuğa giriniz."
							/>
						</Grid>
						<Grid item xs={12}>
							<RxTextField
								fullwidth
								id="code"
								name="code"
								label="Doğrulama Kodu"
								value={formik.values.code}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
								placeholder="Doğrulama Kodu"
								error={Boolean(formik.errors.code)}
								helperText={formik.errors.code}
							/>
						</Grid>
						<Grid item xs={12}>
							<RxButton
								fullWidth
								label="İLETİŞİM E-POSTA ADRESİMİ DOĞRULA"
								variant="contained"
								color="primary"
								disabled={false}
								onClick={() => validateMail()}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</RxDialog>
	);
};

export default MailApprove;
